<template>
  <div class="d-flex p-20 justify-content-center">
  </div>
</template>
<script>
import store from './../mixins/store.mixin'

export default {
  name: "Welcome",
  props: {},
  components: {},
  mixins: [
    store
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
.welcome-card {
  width: 685px;
  background: #424242;
  color: #E8EAED;
}

.welcome-card-item {
  border-bottom: 1px solid #595959;
  padding: 20px;
  display: flex;
  gap: 20px;

  .welcome-card-icon {
  }

  .welcome-card-content {
  }

  h1 {
    font-size: 28px;
    font-weight: 600;
    color: #E8EAED;
  }

  h2 {
    font-size: 17.5px;
    font-weight: 600;
    margin: 0 0 10px 0;
    color: #E8EAED;
  }

  p {
    font-size: 14px;
    font-weight: 400;
  }
}

</style>
